
import { Box } from "@mui/material";
import HintsAutocomplete, { HintRandomizerDto } from "./HintsAutocomplete";
import OotItemContextMenuButton from "./OotItemContextMenuButton";
import { useGetHintDead } from "./HintHelper";
import { isNil } from "lodash";

interface AlwaysHintProps {
    hint?: HintRandomizerDto
    dual?: true
    dualImage?: string
}

const DefaultAlwaysHint = (props: AlwaysHintProps) => {
 
    let dead = useGetHintDead(props.hint);

    return <Box display={"flex"} flexShrink={1} justifyContent={"center"} alignItems={"center"} marginLeft={"5px"}>
        <HintsAutocomplete type="always" value={props.hint} disabled />
        {!isNil(props.dualImage) && <img src={props.dualImage} alt="dual img" width={32} height={32}/>}
        {/* <TextField value={hint} onChange={(e) => setHint(e.currentTarget.value)} label="Location Hint" size="small" sx={{ margin: "2px" }}></TextField> */}
        {/* <Box display="flex" flexDirection={"column"} justifyContent="center" margin={"5px"}> <RightArrow /> </Box> */}
        <OotItemContextMenuButton dead={dead}/>
        {!isNil(props.dual) && <OotItemContextMenuButton dead={dead}/>}
    </Box>
}

export default DefaultAlwaysHint;


export const DbAlwaysHint = () => {
}